import gql from "graphql-tag";

const AllergyProps = gql`
  fragment AllergyProps on Allergy {
    id
    name
    created_at
  }
`;
const LIST = gql`
  query GetAllergies($site: ID!) {
    GetAllergies(site: $site) {
      docs {
        ...AllergyProps
      }
    }
  }
  ${AllergyProps}
`;

const CREATE = gql`
  mutation NewAllergy($name: String!, $site: ID!) {
    NewAllergy(name: $name, site: $site) {
      message
      doc {
        ...AllergyProps
      }
    }
  }
  ${AllergyProps}
`;

const UPDATE = gql`
  mutation UpdateAllergyFunc($id: ID!, $name: String!) {
    UpdateAllergy(id: $id, name: $name) {
      message
      doc {
        ...AllergyProps
      }
    }
  }
  ${AllergyProps}
`;
export { LIST, CREATE, UPDATE };
